import { gql } from 'graphql-request';

import {
  MaterialsSetID,
  MaterialsSetSelectedMaterialsID,
  MaterialsSetSelectedMaterialsMaterialBlocked,
  MaterialsSetSelectedMaterialsMaterialBrandName,
  MaterialsSetSelectedMaterialsMaterialBrandUUID,
  MaterialsSetSelectedMaterialsMaterialFavorite,
  MaterialsSetSelectedMaterialsMaterialID,
  MaterialsSetSelectedMaterialsMaterialImageFile,
  MaterialsSetSelectedMaterialsMaterialImageUUID,
  MaterialsSetSelectedMaterialsMaterialName,
  MaterialsSetSelectedMaterialsMaterialNanoID,
  MaterialsSetSelectedMaterialsMaterialNda,
  MaterialsSetSelectedMaterialsMaterialUUID,
  MaterialsSetSelectedMaterialsUUID,
  MaterialsSetUUID
} from '../materialsSetsTypes';

export interface FetchMaterialsSetByUserIdQueryResponse {
  id: MaterialsSetID;
  uuid: MaterialsSetUUID;
  selectedMaterials: {
    id: MaterialsSetSelectedMaterialsID;
    uuid: MaterialsSetSelectedMaterialsUUID;
    materialId: MaterialsSetSelectedMaterialsMaterialID;
    material: {
      id: MaterialsSetSelectedMaterialsMaterialID;
      uuid: MaterialsSetSelectedMaterialsMaterialUUID;
      nanoId: MaterialsSetSelectedMaterialsMaterialNanoID;
      name: MaterialsSetSelectedMaterialsMaterialName;
      nda: MaterialsSetSelectedMaterialsMaterialNda;
      blocked: MaterialsSetSelectedMaterialsMaterialBlocked;
      favorite: MaterialsSetSelectedMaterialsMaterialFavorite;
      image: {
        uuid: MaterialsSetSelectedMaterialsMaterialImageUUID;
        file: MaterialsSetSelectedMaterialsMaterialImageFile;
      };
      brand: {
        uuid: MaterialsSetSelectedMaterialsMaterialBrandUUID;
        name: MaterialsSetSelectedMaterialsMaterialBrandName;
      };
    };
  }[];
}

export const FETCH_MATERIALS_SET_BY_USER_ID_QUERY = gql`
  query MaterialsSetByUserId($userId: ID!, $scope: ID) {
    materialsSetByUserId(userId: $userId, scope: $scope) {
      id
      uuid
      selectedMaterials {
        id
        uuid
        materialId
        material {
          id
          uuid
          nanoId
          name
          nda
          blocked
          favorite
          image {
            uuid
            file
          }
          brand {
            uuid
            name
          }
        }
      }
    }
  }
`;
